module.exports = __webpack_public_path__ + "static/media/MyKinsContract1405-1406.75fc4e8d.pdf";